// ============================================
// Utils - Global Loading Overlay (ES6)
// 전역 로딩 오버레이 기능
// ============================================

let loadingVisible = false;
let kaomojInterval = null;
let lastKaomojiIndex = -1;

// 카오모지 표정 목록 (100개) - 비슷한 크기로 통일
const KAOMOJIS = [
  '(◕‿◕)', '(◠‿◠)', '(◕ᴗ◕)', '(◠ᴗ◠)', '(◕◡◕)',
  '(◠◡◠)', '(◕ω◕)', '(◠ω◠)', '(◕▽◕)', '(◠▽◠)',
  '(◕‿‿◕)', '(◠‿‿◠)', '(◕ᴗᴗ◕)', '(◠ᴗᴗ◠)', '(◕◡◡◕)',
  '(•‿•)', '(•ᴗ•)', '(•◡•)', '(•ω•)', '(•▽•)',
  '(´◡`)', '(´ω`)', '(´▽`)', '(´‿`)', '(´ᴗ`)',
  '(ᵔ‿ᵔ)', '(ᵔᴗᵔ)', '(ᵔ◡ᵔ)', '(ᵔωᵔ)', '(ᵔ▽ᵔ)',
  '(˘‿˘)', '(˘ᴗ˘)', '(˘◡˘)', '(˘ω˘)', '(˘▽˘)',
  '(^‿^)', '(^ᴗ^)', '(^◡^)', '(^ω^)', '(^▽^)',
  '(≧‿≦)', '(≧ᴗ≦)', '(≧◡≦)', '(≧ω≦)', '(≧▽≦)',
  '(◔‿◔)', '(◔ᴗ◔)', '(◔◡◔)', '(◔ω◔)', '(◔▽◔)',
  '(ㆁᴗㆁ)', '(ㆁ‿ㆁ)', '(ㆁ◡ㆁ)', '(ㆁωㆁ)', '(ㆁ▽ㆁ)',
  '(◠‸◠)', '(◕‸◕)', '(•‸•)', '(ᵔ‸ᵔ)', '(˘‸˘)',
  '(◠︿◠)', '(◕︿◕)', '(•︿•)', '(ᵔ︿ᵔ)', '(˘︿˘)',
  '(◠_◠)', '(◕_◕)', '(•_•)', '(ᵔ_ᵔ)', '(˘_˘)',
  '(◠.◠)', '(◕.◕)', '(•.•)', '(ᵔ.ᵔ)', '(˘.˘)',
  '(◠∀◠)', '(◕∀◕)', '(•∀•)', '(ᵔ∀ᵔ)', '(˘∀˘)',
  '(◠◠)', '(◕◕)', '(••)', '(ᵔᵔ)', '(˘˘)',
  '(○‿○)', '(○ᴗ○)', '(○◡○)', '(○ω○)', '(○▽○)',
  '(ꈍᴗꈍ)', '(ꈍ‿ꈍ)', '(ꈍ◡ꈍ)', '(ꈍωꈍ)', '(ꈍ▽ꈍ)',
  '(◡‿◡)', '(◡ᴗ◡)', '(◡◡◡)', '(◡ω◡)', '(◡▽◡)'
];

// 이전과 다른 랜덤 인덱스 반환
function getRandomKaomojiIndex() {
  let index;
  do {
    index = Math.floor(Math.random() * KAOMOJIS.length);
  } while (index === lastKaomojiIndex && KAOMOJIS.length > 1);
  lastKaomojiIndex = index;
  return index;
}

export function showGlobalLoading() {
  loadingVisible = true;
  let overlay = document.getElementById('globalLoadingOverlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.id = 'globalLoadingOverlay';
    overlay.innerHTML = `<div class="kaomoji-face"></div>`;
    document.body.appendChild(overlay);
  }

  const face = overlay.querySelector('.kaomoji-face');
  if (face) {
    // 초기 표정 설정
    face.textContent = KAOMOJIS[getRandomKaomojiIndex()];

    // 기존 인터벌 정리
    if (kaomojInterval) {
      clearInterval(kaomojInterval);
    }

    // 빠르게 표정 변경 (100ms 간격)
    kaomojInterval = setInterval(() => {
      if (loadingVisible && face) {
        face.textContent = KAOMOJIS[getRandomKaomojiIndex()];
      }
    }, 100);
  }

  overlay.style.display = 'flex';
  requestAnimationFrame(() => {
    if (loadingVisible) {
      overlay.classList.add('visible');
    }
  });
}

export function hideGlobalLoading() {
  loadingVisible = false;

  // 인터벌 정리
  if (kaomojInterval) {
    clearInterval(kaomojInterval);
    kaomojInterval = null;
  }

  const overlay = document.getElementById('globalLoadingOverlay');
  if (overlay) {
    overlay.classList.remove('visible');
    setTimeout(() => {
      if (!loadingVisible) {
        overlay.style.display = 'none';
      }
    }, 200);
  }
}

// window 노출 제거됨 (2026-01-06) - import로 사용
